import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";
import SearchAndFilter from "../../../components/Search/SearchAndFilter";

import moment from "moment";

import {
  getAlert,
  getDataWithComp,
} from "../../../../utils/SamuiUtils";

function Main({
  masterList,
  detailList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  getReport,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(
    localStorage.getItem("itemsPerPageDropdown") || 10
  );
  const [countWaitApprove, setCountWaitApprove] = useState(0);
  const [countApprove, setCountApprove] = useState(0);
  const [countNotApprove, setCountNotApprove] = useState(0);
  const [countCancel, setCountCancel] = useState(0);

  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("searchTerm") || ""
  );
  const [filteredItems, setFilteredItems] = useState([]);

  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem("startDate");
    return storedStartDate || moment().startOf("month").format("YYYY-MM-DD");
  });
  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem("endDate");
    return storedEndDate || moment().endOf("month").format("YYYY-MM-DD");
  });
  const [dateType, setDateType] = useState("1");

  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    initialize();
  }, [masterList, detailList]);

  useEffect(() => {
    if (dataMasterList && dataMasterList.length > 0) {
      setCurrentPage(1);
      filterItems();
      localStorage.setItem("searchTerm", searchTerm);
    }
  }, [searchTerm, dataMasterList, selectedStatus]);

  useEffect(() => {
    if (dataMasterList && dataMasterList.length > 0) {
      setCurrentPage(1);
      filterItems();
      localStorage.setItem("startDate", startDate);
      localStorage.setItem("endDate", endDate);
    }
  }, [startDate, endDate, dataMasterList, selectedStatus]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        const image = await getDataWithComp(
          "Upload_File_List",
          `AND DocCode_ID = 1`
        );

        const updatedMasterList = masterList.map((item) => {
          const relatedFiles = image.filter(
            (img) => img.Doc_ID === item.Doc_ID
          );

          return {
            ...item,
            File_Name: relatedFiles.map((file) => file.File_Name),
          };
        });

        setDataMasterList(updatedMasterList);

        let statusCounts = {
          รออนุมัติ: 0,
          อนุมัติ: 0,
          ไม่อนุมัติ: 0,
          ยกเลิก: 0,
        };

        masterList.forEach((data) => {
          if (data.DocStatus_Name) {
            statusCounts[data.DocStatus_Name] =
              (statusCounts[data.DocStatus_Name] || 0) + 1;
          }
        });

        setCountWaitApprove(statusCounts["รออนุมัติ"]);
        setCountApprove(statusCounts["อนุมัติ"]);
        setCountNotApprove(statusCounts["ไม่อนุมัติ"]);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const filterItems = () => {
    try {
      if (!dataMasterList || dataMasterList.length === 0) {
        setFilteredItems([]);
        return;
      }

      let filtered = [...dataMasterList];

      // Date filtering
      const start = moment(startDate, "YYYY-MM-DD");
      const end = moment(endDate, "YYYY-MM-DD");

      filtered = filtered.filter((item) => {
        const itemDate =
          dateType === "1"
            ? moment(item.Doc_Date, "YYYY-MM-DD")
            : moment(item.Doc_DueDate, "YYYY-MM-DD");
        return itemDate.isBetween(start, end, null, "[]");
      });

      // Search filtering
      if (searchTerm.trim() !== "") {
        const lowercasedSearchTerm = searchTerm.toLowerCase();
        filtered = filtered.filter((item) =>
          (item.Doc_No && item.Doc_No.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.AP_Code && item.AP_Code.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.AP_Name && item.AP_Name.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.Emp_Name && item.Emp_Name.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.Dept_Name && item.Dept_Name.toLowerCase().includes(lowercasedSearchTerm)) ||
          (item.DocStatus_Name && item.DocStatus_Name.toLowerCase().includes(lowercasedSearchTerm))
        );
      }

      // ฟิลเตอร์ตามสถานะที่เลือก
      if (selectedStatus) {
        filtered = filtered.filter((item) => item.DocStatus_Name === selectedStatus);
      }

      setFilteredItems(filtered);
    } catch (error) {
      console.error('Filter error:', error.message);
      setFilteredItems([]);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleStatusClick = (statusName) => {
    if (selectedStatus === statusName) {
      setSelectedStatus(null);
    } else {
      setSelectedStatus(statusName);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header | d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "จัดซื้อสินค้า", url: "/purchase" },
            { name: name, url: "/purchase-request" },
          ]}
        />
      </div>
      <div className="row" style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="col-1">
          <center>
            <b>สถานะเอกสาร</b>
          </center>
          <br />
          {statusColours.map((statusObj, index) => {
            const { DocSetStaus_Name, DocSetColour } = statusObj;
            let count;

            switch (DocSetStaus_Name) {
              case "รออนุมัติ":
                count = countWaitApprove;
                break;
              case "อนุมัติ":
                count = countApprove;
                break;
              case "ไม่อนุมัติ":
                count = countNotApprove;
                break;
              case "ยกเลิก":
                count = countCancel;
                break;
              default:
                count = 0;
            }

            return (
              <div
                key={index}
                className="col-12 mb-3"
                onClick={() => handleStatusClick(DocSetStaus_Name)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card text-center"
                  style={{
                    backgroundColor: DocSetColour,
                    boxShadow: selectedStatus === DocSetStaus_Name ? "0 0 15px rgba(0,0,0,0.5)" : "none",
                    border: selectedStatus === DocSetStaus_Name ? "2px solid #333" : "none",
                    transform: selectedStatus === DocSetStaus_Name ? "scale(1.05)" : "scale(1)",
                    transition: "transform 0.15s, box-shadow 0.15s, border 0.15s",
                  }}
                >
                  <div className="card-body d-flex flex-column align-items-center text-white">
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "20px", textAlign: "center" }}>
                          {count}
                        </b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "16px", textAlign: "center" }}>
                          {DocSetStaus_Name}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-11">
          {/* Search and Filter Section */}
          <SearchAndFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchPlaceholder="ค้นหาเลขเอกสาร, ผู้จำหน่าย, พนักงาน, แผนก..."
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            showDateFilter={true}
            onAddNew={onPageInsert}
            addButtonText={`สร้าง${name}`}
            showAddButton={true}
          />
          <DataTable
            currentItems={currentItems}
            onRowSelected={onRowSelected}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            dataMasterList={filteredItems}
            setDataMasterList={setFilteredItems}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            fieldMappings={{
              no: "Doc_No",
              typeName: "DocType_Name",
              statusName: "DocStatus_Name",
              statusColor: "docsetcolour",
              printedStatus: 'Printed_Status',
              date: "Doc_Date",
              apCode: "AP_Code",
              apName: "AP_Name",
              dueDate: "Doc_DueDate",
              netTotal: "NetTotal",
              createdBy: "Created_By_Name",
              updatedBy: "Update_By_Name",
              File_Name: "File_Name",
              empName: "Emp_Name",
              deptName: "Dept_Name",
            }}
            getReport={(docNo) => {
              (async () => {
                try {
                  await getReport("pr", docNo);
                } catch (e) {
                  console.error(e);
                } finally {
                  await initialize();
                }
              })();
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Main;
